import { render, staticRenderFns } from "./ModalImportarSigtap.vue?vue&type=template&id=fda052fc&scoped=true"
import script from "./ModalImportarSigtap.vue?vue&type=script&lang=js"
export * from "./ModalImportarSigtap.vue?vue&type=script&lang=js"
import style0 from "./ModalImportarSigtap.vue?vue&type=style&index=0&id=fda052fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda052fc",
  null
  
)

export default component.exports